"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _framerMotion = require("framer-motion");
var _uuid = require("uuid");
var _reactI18next = require("react-i18next");
var _PanelModule = _interopRequireDefault(require("./Panel.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const Panel = _ref => {
  let {
    disabled,
    id,
    classNameTrigger,
    classNameTriggerExpanded,
    classNameContent,
    testAttrTrigger,
    testAttrContent,
    isOpen,
    trigger,
    content,
    onToggle,
    customRender,
    onKeyDown
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    current: uuid
  } = (0, _react.useRef)((0, _uuid.v4)());
  const [isExpanded, setIsExpanded] = (0, _react.useState)(isOpen);
  const triggerId = "trigger-".concat(uuid);
  const contentId = "content-".concat(uuid);
  const onClick = () => {
    const expanded = !isExpanded;
    setIsExpanded(expanded);
    if (onToggle) {
      onToggle({
        id,
        isExpanded: expanded
      });
    }
  };
  (0, _react.useEffect)(() => {
    setIsExpanded(isOpen);
  }, [isOpen]);
  const triggerProps = _objectSpread({
    onClick,
    disabled,
    onKeyDown,
    id: triggerId,
    className: (0, _cnbuilder.cnb)(_PanelModule.default.triggerContainer, classNameTrigger, {
      [classNameTriggerExpanded]: isExpanded
    }),
    children: trigger,
    'data-panel-trigger': true,
    'data-test': testAttrTrigger,
    'aria-expanded': isExpanded ? 'true' : 'false'
  }, isExpanded && {
    'aria-controls': contentId
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_framerMotion.LazyMotion, {
    features: _framerMotion.domAnimation,
    children: [customRender ? customRender({
      trigger: triggerProps
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("button", _objectSpread({}, triggerProps)), isExpanded && /*#__PURE__*/(0, _jsxRuntime.jsx)(_framerMotion.AnimatePresence, {
      initial: false,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_framerMotion.m.div, {
        id: contentId,
        className: _PanelModule.default.contentContainer,
        role: "region",
        "aria-labelledby": triggerId,
        initial: "collapsed",
        animate: "open",
        exit: "collapsed",
        variants: {
          open: {
            opacity: 1,
            height: 'auto'
          },
          collapsed: {
            opacity: 0,
            height: 0
          }
        },
        transition: {
          duration: 0.3,
          ease: [0.42, 0, 0.58, 1]
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: (0, _cnbuilder.cnb)(_PanelModule.default.content, classNameContent),
          "data-test": testAttrContent,
          children: content
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      role: "status",
      "aria-live": "polite",
      className: "visually-hidden",
      children: isExpanded ? t('ui:panel.expanded') : t('ui:panel.collapsed')
    })]
  });
};
Panel.defaultProps = {
  testAttrTrigger: 'panel-trigger',
  testAttrContent: 'panel-content'
};
var _default = exports.default = Panel;